import { OnInit, Directive, inject, input } from '@angular/core'
import { ButtonComponent, ButtonThemeSize } from './button.component'

@Directive({
  selector: '[btn-text]',
  standalone: false,
})
export class ButtonTextDirective implements OnInit {
  private _button = inject(ButtonComponent)
  ngOnInit(): void {
    this._button.appearance.set('text')
  }
}

@Directive({
  selector: '[btn-outlined]',
  standalone: false,
})
export class ButtonOutlinedDirective implements OnInit {
  private _button = inject(ButtonComponent)
  ngOnInit(): void {
    this._button.appearance.set('outlined')
  }
}

@Directive({
  selector: '[btn-elevated]',
  standalone: false,
})
export class ButtonElevatedDirective implements OnInit {
  private _button = inject(ButtonComponent)
  ngOnInit(): void {
    this._button.appearance.set('elevated')
  }
}

@Directive({
  selector: '[btn-xsmall]',
  standalone: false,
})
export class ButtonXSmallDirective implements OnInit {
  private _button = inject(ButtonComponent)
  ngOnInit(): void {
    this._button.themeSize.set(ButtonThemeSize.XSmall)
  }
}

@Directive({
  selector: '[btn-small]',
  standalone: false,
})
export class ButtonSmallDirective implements OnInit {
  private _button = inject(ButtonComponent)
  ngOnInit(): void {
    this._button.themeSize.set(ButtonThemeSize.Small)
  }
}

@Directive({
  selector: '[btn-medium]',
  standalone: false,
})
export class ButtonMediumDirective implements OnInit {
  private _button = inject(ButtonComponent)
  ngOnInit(): void {
    this._button.themeSize.set(ButtonThemeSize.Medium)
  }
}

@Directive({
  selector: '[btn-large]',
  standalone: false,
})
export class ButtonLargeDirective implements OnInit {
  private _button = inject(ButtonComponent)
  ngOnInit(): void {
    this._button.themeSize.set(ButtonThemeSize.Large)
  }
}

@Directive({
  selector: '[btn-xlarge]',
  standalone: false,
})
export class ButtonXLargeDirective implements OnInit {
  private _button = inject(ButtonComponent)
  ngOnInit(): void {
    this._button.themeSize.set(ButtonThemeSize.XLarge)
  }
}

@Directive({
  selector: '[btn-responsive]',
  standalone: false,
})
export class ButtonResponsiveDirective implements OnInit {
  private _button = inject(ButtonComponent)
  btnResponsive = input<'small'|'medium'|'large'|'xlarge'>('medium', {
    alias: 'btn-responsive',
  })

  ngOnInit(): void {
    switch (this.btnResponsive()) {
      case 'small':
        this._button.themeSize.set(ButtonThemeSize.ResponsiveSmall)
        break
      case 'medium':
        this._button.themeSize.set(ButtonThemeSize.ResponsiveMedium)
        break
      case 'large':
        this._button.themeSize.set(ButtonThemeSize.ResponsiveLarge)
        break
      case 'xlarge':
        this._button.themeSize.set(ButtonThemeSize.ResponsiveXLarge)
        break
    }

  }
}
